<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="人员" style="width: 250px" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="人员" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="职位" min-width="100" prop="zhiwei"></el-table-column>
          
          <el-table-column align="center" label="客户编号" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="生产单号" min-width="100" prop="shengchandanhao"></el-table-column>
          <el-table-column align="center" label="产品编码" min-width="100" prop="chanpinbianma"></el-table-column>
          <el-table-column align="center" label="产品名称" min-width="100" prop="chanpinmingcheng"></el-table-column>
          
          <el-table-column align="center" label="工序" min-width="100" prop="gongxu"></el-table-column>
          <el-table-column align="center" label="程控单价" min-width="100" prop="chengkongdanjia"></el-table-column>
          <el-table-column align="center" label="执行单价" min-width="100" prop="zhixingdanjia"></el-table-column>
          <el-table-column align="center" label="单价" min-width="100" prop="danjia"></el-table-column>
          <el-table-column align="center" label="产量" min-width="100" prop="chanliang"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="人员" prop="renyuan">
          <div style="display: flex;">
            <el-input v-model="editForm.renyuan" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.renyuan" filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in memberSelectList"
                :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="职位" prop="zhiwei">
          <div style="display: flex;">
            <el-input v-model="editForm.zhiwei" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.zhiwei" filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in zhiweiSelectList"
                :key="index" :label="item.zhiwei" :value="item.zhiwei">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        
        <el-form-item label="客户编号" prop="kehu">
          <el-select v-model="orderValue" filterable placeholder="请选择"
            @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.kehu+'_'+item.shengchandanhao+'_'+item.chanpinbianma+'_'+item.chanpinmingcheng"
              :label="item.kehu+'_'+item.shengchandanhao+'_'+item.chanpinbianma+'_'+item.chanpinmingcheng" 
              :value="item.kehu+'_'+item.shengchandanhao+'_'+item.chanpinbianma+'_'+item.chanpinmingcheng">
            </el-option>
          </el-select>
          <el-input v-model="editForm.kehu" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="生产单号" prop="shengchandanhao">
          <el-input v-model="editForm.shengchandanhao"></el-input>
        </el-form-item>
        <el-form-item label="产品编码" prop="chanpinbianma">
          <el-input v-model="editForm.chanpinbianma"></el-input>
        </el-form-item>
        <el-form-item label="产品名称" prop="chanpinmingcheng">
          <el-input v-model="editForm.chanpinmingcheng"></el-input>
        </el-form-item>
        
        <el-form-item label="工序" prop="gongxu">
          <div style="display: flex;">
            <el-input v-model="editForm.gongxu" style="margin-right: 10px;"></el-input>
            <el-select v-model="gongxuValue" filterable placeholder="请选择" style="width: 400px;"
              @change="gongxuChange" >
              <el-option v-for="(item,index) in gongxuSelectList"
                :key="index" :label="item.gongxu" 
                :value="item.gongxu">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="程控单价" prop="chengkongdanjia">
          <el-input-number v-model="editForm.chengkongdanjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="执行单价" prop="zhixingdanjia">
          <el-input-number v-model="editForm.zhixingdanjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="单价" prop="danjia">
          <el-input-number v-model="editForm.danjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="当日产量" prop="chanliang">
          <el-input-number v-model="editForm.chanliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    renyuan: "",
    zhiwei: "",
    
    kehu: "",
    shengchandanhao: "",
    chanpinbianma: "",
    chanpinmingcheng: "",
    
    gongxu: "",
    chengkongdanjia: 0,
    zhixingdanjia: 0,
    danjia: 0,
    chanliang: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      gongxuSelectList: [],
      zhiweiSelectList: [],
      orderValue: '',
      gongxuValue: '',
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
    this.getMemberSelectList()
    this.getZhiweiSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].kehu==arr[0]&&this.orderSelectList[i].shengchandanhao==arr[1]
          &&this.orderSelectList[i].chanpinbianma==arr[2]&&this.orderSelectList[i].chanpinmingcheng==arr[3]) {
          this.editForm.kehu = this.orderSelectList[i].kehu
          this.editForm.shengchandanhao = this.orderSelectList[i].shengchandanhao
          this.editForm.chanpinbianma = this.orderSelectList[i].chanpinbianma
          this.editForm.chanpinmingcheng = this.orderSelectList[i].chanpinmingcheng
          this.editForm.hetongshuliang = this.orderSelectList[i].hetongshuliang
          
          this.editForm.gongxu = ''
          this.gongxuValue = ''
          this.editForm.chengkongdanjia = 0
          this.editForm.zhixingdanjia = 0
          this.editForm.danyongliang = 0
          this.editForm.danjia = 0
          
          if(this.orderSelectList[i].gongxuArr) {
            this.gongxuSelectList = JSON.parse(this.orderSelectList[i].gongxuArr)
          }else{
            this.gongxuSelectList = []
          }
        }
      }
    },
    
    gongxuChange(e) {
      for(let i in this.gongxuSelectList) {
        if(this.gongxuSelectList[i].gongxu==e) {
          this.editForm.gongxu = this.gongxuSelectList[i].gongxu
          this.editForm.chengkongdanjia = this.gongxuSelectList[i].chengkongdanjia
          this.editForm.zhixingdanjia = this.gongxuSelectList[i].zhixingdanjia
          this.editForm.danjia = this.gongxuSelectList[i].danjia
          this.editForm.danyongliang = this.gongxuSelectList[i].danyongliang
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/gongzimodel/hanjieMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getZhiweiSelectList() {
      this.$request.post('/index.php/admin/admin/zhiweiSelect').then((res) => {
        this.zhiweiSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.renyuan) {
        this.editForm.renyuan = form.renyuan
      }
      if(form.zhiwei) {
        this.editForm.zhiwei = form.zhiwei
      }
      if(form.kehu) {
        this.editForm.kehu = form.kehu
        this.editForm.shengchandanhao = form.shengchandanhao
        this.editForm.chanpinbianma = form.chanpinbianma
        this.editForm.chanpinmingcheng = form.chanpinmingcheng
        this.editForm.hetongshuliang = form.hetongshuliang
      }
      if(form.gongxu) {
        this.editForm.gongxu = form.gongxu
        this.editForm.chengkongdanjia = form.chengkongdanjia
        this.editForm.zhixingdanjia = form.zhixingdanjia
        this.editForm.danyongliang = form.danyongliang
        this.editForm.danjia = form.danjia
      }
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/gongzi/hjgzInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/gongzi/hjgzDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/gongzi/hjgzSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/gongzi/hjgzList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
